import { BackIcon } from 'shared/icons/BackIcon'
import styles from './BackButton.module.css'

interface BackButtonProps{
    onClick?: (event: any) => void
}

export const BackButton = (props: BackButtonProps): JSX.Element => {
    const {
        onClick
    } = props

    const handleButtonClick = (event: any) => {
        onClick?.(event)
    }

    return (
        <button
            className={styles.BackButton}
            onClick={handleButtonClick}
        >
            <BackIcon />
        </button>
    )
}